import CategoriesMenu from './categoriesMenu'

export default CategoriesMenu
